export const CATEGORY_TYPES = {
  CASH_IN: 'cash_in',
  CASH_OUT: 'cash_out',
};

export const CATEGORY_TYPE_OPTIONS = [
  { value: CATEGORY_TYPES.CASH_IN, label: 'Receita' },
  { value: CATEGORY_TYPES.CASH_OUT, label: 'Custo' },
];

export const translateCategoryType = (type) => {
  const translations = {
    [CATEGORY_TYPES.CASH_IN]: 'Receita',
    [CATEGORY_TYPES.CASH_OUT]: 'Custo',
  };
  return translations[type] || type;
};

export const validateCategoryForm = (formData) => {
  const errors = {};

  if (!formData.name || formData.name.trim().length < 2) {
    errors.name = 'Nome deve ter no minimo 2 caracteres';
  }

  if (!formData.categoryType) {
    errors.categoryType = 'Tipo de categoria e obrigatorio';
  }

  return errors;
};
